export interface IrecruitmentInfoData {
  id: number;
  title: string;
  description: string;
}
export const recruitmentInfoData: IrecruitmentInfoData[] = [
  {
    id: 1,
    title: "Review",
    description:
      "Our deep understanding of the enterprise psyche, coupled with multi-dimensional analytical technique enables us to assess issues and suggest solution approaches in alignment with a global vision. Our experience of more than two decades in the human talent sourcing business has helped us to create powerful tool for assessing the organizational climate, employee attitude, employee morale, motivation and commitment to the organizational goals and advising the corporate world about remedial solutions.",
  },
  {
    id: 2,
    title: "Initial Document Process",
    description:
      "On receipt of job order request, a consultant is assigned to the portfolio. A set of documents is usually required for overseas recruitment from most countries and in most cased these need to be legalised in the respective embassies. Our cunsultant will provide the draft set of these documents.",
  },
  {
    id: 3,
    title: "ADVERTISEMENT",
    description:
      "Advertisements are placed in local and regional media, in order to attract the best available candidate. We also place a huge emphasis on online job boards and forums and actively promote all vacancies.",
  },
  {
    id: 4,
    title: "TRADE TEST",
    description:
      "For skilled categories, trade tests are conducted at approved centre.",
  },
  {
    id: 5,
    title: "PRESCREENING AND FORWARDING",
    description:
      "Our consultant screens them before forwarding it to the client for consideration.",
  },
  {
    id: 6,
    title: "INTERVIEW",
    description:
      "We will arrange for the candidates to be interviewed as agreed and convenient. Video conferencing, skype and/or telephonic interviews may be arranged as required.",
  },
  {
    id: 7,
    title: "MEDICAL FITNESS",
    description:
      "Once the candidates are short listed and selected, a reference check may be conducted based on the position recruited for. All selected candidates have to undergo a compulsory medical fitness test.",
  },
  {
    id: 8,
    title: "EMPLOYMENT AGREEMENT",
    description:
      "On receipt of appointment letters, required documents for visa application are processed and dispatched to the client. Constant co-ordination is maintained between the client’s office and our associates all over our country to ensure that the candidates are mobilised in the shortest possible time. (Screens the short-listed candidates by pre-interview.)",
  },
  {
    id: 9,
    title: "ORIENTATION",
    description:
      "Prior to the departure of workers the orientation briefing is organized to make all workers fully aware of the employment company, country’s laws and orders, labor laws immigration policy and maintain understanding and cordiality them  self and aim of the particular activity of the individual. The Orientation takes special care in briefing them to strictly abide by the guide lines in the field of their employment and direct them to maintain good circumstance and motivate them to their duties/responsibilities.",
  },
  {
    id: 10,
    title: "TRAVELLING ARRANGEMENT",
    description:
      "In all case, we send all the visa endorsement, passport to the concerned airlines, to confirm the scheduled flight from Nepal to destination country. PTA to any airlines operating from Kathmandu shall be sent after our final confirmation.",
  },
  {
    id: 11,
    title: "TERMINATION OF EMPLOYMENT",
    description:
      "In case of any termination of any employee under non performance or disciplinary action Client should provide concrete evidence and termination letter along with exit interview details addressing Suhara Foreign Employment Agency and a CC to the Ministry of Labor Nepal.",
  },
];
